import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { authInterceptor } from '../../auth/interceptors/auth.interceptor';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { metaReducers, reducers } from '../../reducers';
import { environment } from '../../../environments/environment';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ServiceWorkerModule } from '@angular/service-worker';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { TdAppComponent } from './td-app.component';
import { TdAppRoutingModule } from './td-app-routing.module';
import { KeycloakAuthModule } from '../../auth/providers/keycloak/keycloak-auth.module';
import { MatTabsModule } from '@angular/material/tabs';
import { TdStartFlowModule } from './start-flow/td-start-flow.module';
import { provideNoOpModalController } from '../../core/providers/no-op-modal-controller.provider';

@NgModule({
  declarations: [TdAppComponent],
  bootstrap: [TdAppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatTabsModule,
    EffectsModule.forRoot([]),
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    environment.reduxToolsEnabled
      ? StoreDevtoolsModule.instrument({
          maxAge: environment.reduxMaxAge,
          logOnly: environment.production,
          serialize: true,
          connectInZone: true,
          actionsBlocklist: [
            '[SdSVG / Others] Sd Cache element Added',
            '[SdSVG] Sd Cache New Image Requested',
            '@ngrx/store/update-reducers',
          ],
        })
      : [],
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    StoreRouterConnectingModule.forRoot(),
    TdAppRoutingModule,
    TdStartFlowModule,
    KeycloakAuthModule.forRoot(),
  ],
  providers: [
    provideHttpClient(
      withInterceptors([authInterceptor]),
      withInterceptorsFromDi()
    ),
    provideNoOpModalController(),
  ],
})
export class TdAppModule {}
